import { Component, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../services/user.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import {
  MatAutocompleteSelectedEvent,
  MatDatepickerInputEvent,
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
} from "@angular/material";
import * as moment from "moment";
import { TableUtil } from "../admintrademaster/tableUtil";
import { NotificationsService } from "angular2-notifications";
import { ProperJsonDialogComponent } from "../properJsonDialog/properjsondialog.component";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";

@Component({
  selector: "app-payout",
  templateUrl: "./payout.component.html",
  styleUrls: ["./payout.component.css"],
})
export class PayoutComponent implements OnInit {
  _csrf: string;
  displayedColumns: string[] = ["status", "request_id", "createdAt"];
  dataSource = new MatTableDataSource<any>([]);
  filteredDataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  request_id: string = "";
  oPayouts: any = [];
  payouts: any = [];
  oPayoutRows: any = [];
  rowStatus: string = "";
  payoutRows: any = [];
  filter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  rowsFilter: any = {
    page: 1,
    limit: 15,
    fromDate: moment().subtract(3, "d").format("YYYY-MM-DD"),
    toDate: moment().format("YYYY-MM-DD"),
  };
  prev_disabled = true;
  next_disabled = false;
  rows_prev_disabled = true;
  rows_next_disabled = false;

  // AG Grid - Payout Requests list
  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];

  // AG Grid - Request Items (rows) detail view
  private rowsGridApi: GridApi;
  private rowsGridColumnApi: ColumnApi;
  rowsGridOptions: GridOptions;
  rowsColumnDefs: ColDef[] = [];

  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100,
    cellStyle: { display: "flex", alignItems: "center" },
  };

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private spinnerService: Ng4LoadingSpinnerService,
    private dialog: MatDialog
  ) {
    this.initializeGrids();
  }

  ngOnInit() {
    this.csrf();
  }

  private actionButton(
    label: string,
    iconClass: string,
    btnClass: string,
    onClick: (e: MouseEvent) => void
  ): HTMLButtonElement {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = `btn btn-sm ${btnClass}`;
    btn.title = label;
    btn.style.display = "flex";
    btn.style.alignItems = "center";
    btn.style.justifyContent = "center";
    btn.style.padding = "4px 8px";
    btn.innerHTML = `<i class="fa ${iconClass}"></i>`;
    btn.onclick = (e) => {
      e.stopPropagation();
      onClick(e);
    };
    return btn;
  }

  initializeGrids() {
    this.columnDefs = [
      {
        headerName: "Action",
        field: "action",
        sortable: false,
        filter: false,
        minWidth: 150,
        cellStyle: { display: "flex", alignItems: "center", justifyContent: "flex-start" },
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement("div");
          container.style.display = "flex";
          container.style.alignItems = "center";
          (container.style as any).gap = "5px";

          container.appendChild(
            this.actionButton("View", "fa-eye", "btn-info", () =>
              this.showRows(element._id)
            )
          );

          if (element.status == "PENDING") {
            container.appendChild(
              this.actionButton("Approve", "fa-check", "btn-success", () =>
                this.processPayout("approve", element._id)
              )
            );
            container.appendChild(
              this.actionButton("Reject", "fa-times", "btn-danger", () =>
                this.processPayout("reject", element._id)
              )
            );
          }

          return container;
        },
      },
      { headerName: "Total Amount", field: "total_amount" },
      {
        headerName: "Time",
        field: "createdAt",
        valueFormatter: (params) =>
          params.value ? moment(params.value).format("MMM DD, YYYY hh:mm:ss A") : "",
      },
      { headerName: "Status", field: "status" },
      {
        headerName: "Name",
        field: "userid.name",
        valueGetter: (params) =>
          params.data && params.data.userid ? params.data.userid.name : "",
      },
      { headerName: "Total Failed", field: "total_failed_amount" },
      { headerName: "Comment", field: "comment" },
      { headerName: "Request ID", field: "request_id" },
    ];

    this.gridOptions = {
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: [],
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };

    this.rowsColumnDefs = [
      {
        headerName: "Action",
        field: "action",
        sortable: false,
        filter: false,
        minWidth: 90,
        cellStyle: { display: "flex", alignItems: "center", justifyContent: "flex-start" },
        cellRenderer: (params) => {
          const element = params.data;
          const container = document.createElement("div");
          container.style.display = "flex";
          container.style.alignItems = "center";

          container.appendChild(
            this.actionButton("View JSON", "fa-eye", "btn-info", () =>
              this.displayProperJson(element, "Payout Request")
            )
          );

          return container;
        },
      },
      {
        headerName: "Time",
        field: "createdAt",
        valueFormatter: (params) =>
          params.value ? moment(params.value).format("MMM DD, YYYY hh:mm:ss A") : "",
      },
      { headerName: "Status", field: "status" },
      { headerName: "Req ID", field: "request_id" },
      { headerName: "Payout Order ID", field: "payout_ref_id" },
      { headerName: "Bank Ref ID", field: "BankRefId" },
      { headerName: "Amount", field: "amount" },
      { headerName: "Mode", field: "payment_mode" },
      { headerName: "IFSC", field: "beneficiary_ifsc" },
      { headerName: "Account No", field: "beneficiary_acc_number" },
      { headerName: "Beneficiary Name", field: "beneficiary_name" },
      { headerName: "Remarks", field: "remarks" },
      { headerName: "Reason", field: "statusReason" },
    ];

    this.rowsGridOptions = {
      columnDefs: this.rowsColumnDefs,
      defaultColDef: this.defaultColDef,
      rowData: [],
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    };
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  onRowsGridReady(params) {
    this.rowsGridApi = params.api;
    this.rowsGridColumnApi = params.columnApi;
    this.rowsGridApi.sizeColumnsToFit();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
      }
    );
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    } else {
      this.rowsFilter.page++;
      this.showRows();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    } else {
      if (this.rowsFilter.page > 1) {
        this.rowsFilter.page--;
        this.showRows();
      }
    }
  }

  goBack() {
    this.request_id = "";
    this.payoutRows = [];
  }

  fromDateFilter(event: MatDatepickerInputEvent<Date>, type: Number = 1) {
    if (event.value) {
      console.log(event.value, "event value");
      if (type == 1) {
        this.filter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      } else {
        this.rowsFilter["fromDate"] = moment(event.value).format("YYYY-MM-DD");
      }
    }
  }

  toDateFilter(event: MatDatepickerInputEvent<Date>) {
    if (event.value) {
      this.filter["toDate"] = moment(event.value).format("YYYY-MM-DD");
    }
  }

  applyFilter(filterValue: string): void {
    if (filterValue) {
      this.payouts = this.oPayouts.filter((x: any) => {
        return x.request_id.toLowerCase().includes(filterValue.toLowerCase());
      });
    } else {
      this.payouts = this.oPayouts;
    }
    if (this.gridApi) {
      this.gridApi.setRowData(this.payouts);
    }
  }

  applyFilter2(filterValue: string): void {
    if (filterValue) {
      this.payoutRows = this.oPayoutRows.filter((x: any) => {
        return x.request_id.toLowerCase().includes(filterValue.toLowerCase());
      });
    } else {
      this.payoutRows = this.oPayoutRows;
    }
    if (this.rowsGridApi) {
      this.rowsGridApi.setRowData(this.payoutRows);
    }
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.userService.getPayouts(this.filter).subscribe((list: any) => {
      this.payouts = list;
      this.oPayouts = list;
      if (this.gridApi) {
        this.gridApi.setRowData(this.payouts);
      }
      this.spinnerService.hide();
      if (this.filter.page <= 1) {
        this.prev_disabled = true;
      } else {
        this.prev_disabled = false;
      }
      if (!list || list.length < this.filter.limit) {
        this.next_disabled = true;
      }
    });
  }

  showRows(id: string = null) {
    if (id) {
      this.request_id = id;
    }
    this.spinnerService.show();
    this.rowsFilter.id = this.request_id;
    //this.rowsFilter._csrf = this.csrf;
    this.userService.getPayoutRows(this.rowsFilter).subscribe(
      (list: any) => {
        this.payoutRows = list.rows;
        this.oPayoutRows = list.rows;
        this.rowStatus = list.status;
        if (this.rowsGridApi) {
          this.rowsGridApi.setRowData(this.payoutRows);
        }
        this.spinnerService.hide();
      },
      (err) => {
        this.notifSer.error("Error", "No payout rows found for this request.", {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });
        this.payoutRows = [];
        this.oPayoutRows = [];
        if (this.rowsGridApi) {
          this.rowsGridApi.setRowData(this.payoutRows);
        }
        this.spinnerService.hide();
      }
    );
  }

  displayProperJson(jsonData, eventType) {
    this.dialog.open(ProperJsonDialogComponent, {
      width: "auto",
      height: "auto",
      data: { jsonData, eventType: eventType || "Payout Request" },
    });
  }

  processPayout(action: string, id: string) {
    const request_id = id ? id : this.request_id;
    if (!confirm(`Are you sure you want to ${action} this payout?`)) {
      return;
    }
    this.spinnerService.show();
    let payload = {
      request_id,
      action,
      _csrf: this._csrf,
    };
    this.userService.approveOrReject(payload).subscribe(
      (res) => {
        this.notifSer.success("Success", res.message, {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: true,
          maxLength: 50,
        });

        this.getData();
        this.payoutRows = [];
        this.request_id = "";
        this.spinnerService.hide();
      },
      (err) => {
        this.notifSer.error(
          "Error",
          "Something went wrong, please try again later.",
          {
            timeOut: 3000,
            showProgressBar: true,
            pauseOnHover: false,
            clickToClose: true,
            maxLength: 50,
          }
        );
        this.spinnerService.hide();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/payout/payout.component.ts